class BESSAppSaveAsModal extends BESSAppModal {

    static #instance = null;

    static getInstance() {
        if (this.#instance == null) {
            this.#instance = new BESSAppSaveAsModal();
        }
        return this.#instance;
    }


    constructor() {
        super('saveProjectAsModal');
        this.saveAsOptions = this.view.node.find('input[name="saveAsOption"]');
        this.saveAsVersionInput = this.view.node.find('#saveAsOption_newVersion');
        this.saveAsCopyInput = this.view.node.find('#saveAsOption_newCopy');
        this.doneButton = this.view.node.find('.app-done');
        this.showForSaveAsVersion = this.view.node.find('.show-for-save-as-version');
        this.showForSaveAsCopy = this.view.node.find('.show-for-save-as-copy');
        this.saveAsVersionName = this.showForSaveAsVersion.find('input');
        this.saveAsCopyName = this.showForSaveAsCopy.find('input');
        this.showIfWillBeUpgraded = this.view.node.find('.show-if-will-upgraded');

        this.saveAsVersionName.onChangeKeyUp(this, this.#updateState);
        this.saveAsCopyName.onChangeKeyUp(this, this.#updateState);

        this.saveAsOptions.change(this.#updateState.bind(this));
        this.doneButton.bindClickEvent(this, this.#onDone.bind(this));
    }

    showFor(projectId, projectName, nextVersion, willBeUpgraded, copyOnly=false) {
        this.projectId = projectId;
        this.nextVersion = nextVersion;
        this.projectName = projectName;
        this.projectsApi = BESSApp.instance.services.api.projects;
        this.projectApi = BESSAppProjectAPIService.getFor(projectId);
        this.showIfWillBeUpgraded.showIf(willBeUpgraded);
        this.copyOnly = copyOnly;
        this.#reset();
        if (this.copyOnly) {
            this.saveAsCopyInput.setCheckedIf(true);
        }
        this.#updateState();

        this.open();
    }

    #reset() {
        this.saveAsOptions.setCheckedIf(false);
        this.saveAsVersionName.val('Version ' + this.nextVersion);
        this.saveAsCopyName.val('Copy of ' + this.projectName);
        this.showForSaveAsVersion.addClass('hidden');
        this.showForSaveAsCopy.addClass('hidden');
        this.view.node.removeClass('app-save-as-version').removeClass('app-save-as-copy');
    }

    isSavingAsVersion() {
        return this.saveAsVersionInput.isChecked();
    }

    isSavingAsCopy() {
        return this.saveAsCopyInput.isChecked();
    }

    #updateState() {
        this.showForSaveAsVersion.showIf(this.isSavingAsVersion());
        this.showForSaveAsCopy.showIf(this.isSavingAsCopy());
        this.view.node.addClassIf('app-save-as-version', this.isSavingAsVersion());
        this.view.node.addClassIf('app-save-as-copy', this.isSavingAsCopy());
        this.view.node.find('.app-save-as-options').addClassIf('disabled', this.copyOnly);
        this.view.node.find('.copy-only-alert').showIf(this.copyOnly);
        this.saveAsVersionInput.disableIf(this.copyOnly);

        let versionName = this.saveAsVersionName.val();
        let copyName = this.saveAsCopyName.val();

        let valid = this.isSavingAsVersion() && versionName.length > 0 || this.isSavingAsCopy() && copyName.length > 0;
        this.doneButton.enableIf(valid);
    }

    #onDone() {
        this.close();
        if (this.isSavingAsCopy()) {
            let copyName = this.saveAsCopyName.val();
            this.showDoingWork('Save as...', 'Creating a new copy of this project.');
            this.projectsApi.apiCopy(this.projectId, copyName, this.#onProjectCopied.bind(this))
        } else {
            this.showDoingWork('Save as...', 'Creating a new version of this project.');
            let versionName = this.saveAsVersionName.val();
            this.projectApi.apiCreateVersion(versionName, this.#monitorCreateVersionStatus.bind(this));
        }
    }

    #onProjectCopied() {
        this.projectsApi.apiMonitorCopy(this.projectId, this.#onMonitorProjectCopied.bind(this))
    }

    #onMonitorProjectCopied(result) {
        if ('copying' in result) {
            if (!result.copying) {
                this.hideDoingWork();
                if ('project_url' in result) {
                    window.location.href = result.project_url;
                }
            } else {
                setTimeout(this.#onProjectCopied.bind(this), 2000);
            }
        }
    }

    #monitorCreateVersionStatus(result = null) {
        if (result && result.copied) {
            window.location.href = result.project_url;
        } else {
            this.doDelayed(function () {

                this.projectApi.apiCreateVersionStatus(this.#monitorCreateVersionStatus.bind(this));

            }, 1000);
        }
    }
}